import React from "react";
import { StyledBreadcrumb } from "./styles";

const sections = [
  { key: "Painel de Controle", content: "Painel de Controle", href: "/admin/" },
  { key: "Empresas", content: "Empresas" },
  {
    key: "Solicitacao Empresas",
    content: "Listagem de solicitacoes de empresas",
    active: true,
  },
];

const Back = () => {
  return <StyledBreadcrumb icon="right angle" sections={sections} />;
};

export default Back;
